<template>
<div style="width:100%;margin:15px 0">
  <h4 style="text-align:center;background:#462773;color:aliceblue"> {{title}} </h4>  
  <pre style="width:100%;direction:ltr;max-height:50vh;overflow:auto;border:1px solid #462773">
      {{log}}
  </pre>
</div>
</template>

<script>
export default {
  name: "DD",
  props: ["log","title"],
  mounted() {
      console.log(this.title, this.log)
  }
}
</script>

<style>

</style>